import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@wa/ui";

const TONE = {
  brand: "border-primary/30 bg-primary/10 [&>svg]:text-primary",
  success: "border-success/40 bg-success/10 [&>svg]:text-success",
  neutral: "border-border bg-muted/50 [&>svg]:text-muted-foreground",
} as const;

/**
 * One line the reader should see before the list under it: a quote waits for
 * an answer, a payment is being confirmed, a contract is signed.
 *
 * Tinted from the status tokens, so it follows the theme and dark mode, and
 * always led by a glyph - the tint alone must not be what tells a confirmation
 * from a warning.
 */
export function Notice({
  icon: Icon,
  tone = "brand",
  children,
  className,
}: {
  icon: LucideIcon;
  tone?: keyof typeof TONE;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div role="status" className={cn("flex items-start gap-3 rounded-xl border px-4 py-3 text-sm", TONE[tone], className)}>
      <Icon className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
